import { createSlider } from "@typeform/embed";
import "@typeform/embed/build/css/slider.css";
import { onUnmounted, shallowRef } from "vue";

type TypeformCsatCallbacks = {
  onClose?: () => void;
  onSubmit?: () => void;
};

export function useTypeformCsat() {
  const slider = shallowRef<ReturnType<typeof createSlider> | null>(null);

  const openTypeformCsat = (
    formId: string,
    callbacks?: TypeformCsatCallbacks
  ) => {
    const id = formId?.trim();
    if (!id) return;

    slider.value?.close();

    slider.value = createSlider(id, {
      position: "right",
      width: "390px",
      autoClose: true,
      hideHeaders: true,
      hideFooter: true,
      onClose: callbacks?.onClose,
      onSubmit: callbacks?.onSubmit
    });
    slider.value.open();
  };

  onUnmounted(() => {
    slider.value?.unmount();
    slider.value = null;
  });

  return { openTypeformCsat };
}
